import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const EditHolisticProjectProposalBtn = ({ report }) => {
  const location = useLocation();

  return (
    <>
      <Link
        to={`/holistic-proposals/edit/${report._id}?from=${location.pathname}`}
      >
        <Button icon={<EditOutlined />}>Edit Proposal</Button>
      </Link>
    </>
  );
};

export default EditHolisticProjectProposalBtn;
